import { render } from "./CommentsSection.vue?vue&type=template&id=14a8403d&scoped=true"
import script from "./CommentsSection.vue?vue&type=script&lang=js"
export * from "./CommentsSection.vue?vue&type=script&lang=js"

import "./CommentsSection.vue?vue&type=style&index=0&id=14a8403d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a8403d"]])

export default __exports__